import ComicCard from '@/components/base/ComicCard';
import { getFeaturedComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = getFeaturedComics();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选的热门韩漫，不容错过</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="medium" />
          ))}
        </div>
      </div>
    </section>
  );
}